import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import Description from "@material-ui/icons/Description";

import { NotRequestedDataState } from "altus-datastate";

import {
  getEmployeeCourses,
  clearEmployeeCourses,
} from "features/planner/planner.actions";

import { Format } from "app/app.constants";
import { formatDate } from "utils/format.util";
import CrudBasePage from "app/components/CrudBasePage";
import { ACTIONS } from "features/planner/planner.constants";
import { getActionDataStateFromState } from "app/app.selectors";
import CompetencyStatusIcon from "features/planner/components/CompetencyStatusIcon";
import { getEmployeeCoursesFromState } from "features/planner/employee/employee.selectors";

class EmployeeCoursesContainer extends React.PureComponent {
  columns = [
    {
      xs: 4,
      title: "Course Name",
      getSortProperty: item => item.get("courseName"),
    },
    {
      xs: true,
      title: "Course Type",
      getSortProperty: item => item.get("courseTypeString"),
    },
    {
      xs: true,
      title: "Date Completed",
      getSortProperty: item => formatDate(item.get("endDate"), Format.date),
    },
    {
      xs: true,
      title: "Expires",
      getSortProperty: item =>
        formatDate(item.get("expirationDate"), Format.date),
    },
    {
      xs: true,
      title: "Status",
      getSortProperty: item => item.get("competencyStatus"),
      getValue: item => (
        <CompetencyStatusIcon status={item.get("competencyStatus")} />
      ),
    },
  ];

  actions = [];

  componentDidMount() {
    const { dispatchOnLoad, employeeCardId } = this.props;
    dispatchOnLoad(employeeCardId);
  }

  componentWillUnmount() {
    const { dispatchOnUnload, employeeCardId } = this.props;
    dispatchOnUnload(employeeCardId);
  }

  render() {
    const { Icon, breadcrumb, courses, dataState } = this.props;

    return (
      <CrudBasePage
        Icon={Icon}
        title={breadcrumb}
        items={courses}
        dataState={dataState}
        displaySearchField
        SortableListProps={{
          Icon: Description,
          actions: this.actions,
          columns: this.columns,
          getKey: x => x.get("id"),
        }}
      />
    );
  }

  static defaultProps = {
    dataState: NotRequestedDataState,
  };
}

export default compose(
  connect(
    (state, { employeeCardId }) => ({
      courses: getEmployeeCoursesFromState(state, employeeCardId),
      dataState: getActionDataStateFromState(
        state,
        ACTIONS.GET_EMPLOYEE_COURSES,
      ),
    }),
    {
      dispatchOnLoad: getEmployeeCourses,
      dispatchOnUnload: clearEmployeeCourses,
    },
  ),
)(EmployeeCoursesContainer);
